module.exports = __webpack_public_path__ + "img/web-P4-0-5.2e74c1d6.svg";